var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "linked-record-filter-button" },
    [
      _c(
        "a-button",
        { staticStyle: { width: "100%" }, on: { click: _vm.showRecordPicker } },
        [
          _vm.value
            ? [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.getLinkedRecordLabel()) +
                    "\n        "
                ),
              ]
            : [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("tables.selectRecord")) +
                    "\n        "
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("tables.selectRecord"),
                xlarge: "",
                className: "record-picker-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("RecordPicker", {
                attrs: { "table-id": _vm.getLinkedTableId },
                on: { "record-selected": _vm.onRecordSelected },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }